<template>
  <div class="animated fadeIn">
    <div id="snackbar" style="color:red;"></div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Static Pages</strong>
            <small>Form</small>
          </div>
          <b-form ref="popupform" v-on:submit.prevent.self="submitFinalData">
            <b-row>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="pagesList.main_name"
                    :disabled="editMode ? true : false"
                    :options="pageList"
                    track-by="pop_id"
                    label="pop_name"
                    :multiple="false"
                    placeholder="Select Type"
                    @select="popupSelect"
                    ref="main_name"
                  ></multiselect>
                  <label
                    style="color:red !important;"
                    v-if="error.mpm_id_error_msg"
                    >please select type</label
                  >
                </b-form-group>
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    :options="LanguageArray"
                    :disabled="$route.query.mpm_id ? true : false"
                    :multiple="false"
                    track-by="lang_id"
                    label="lang_name"
                    placeholder="Select Language"
                    v-model="pagesList.language"
                  ></multiselect>
                  <label
                    style="color:red !important;"
                    v-if="error.language_error_msg"
                    >please select language</label
                  >
                </b-form-group>
              </div>
              <div
                class="col-lg-4 col-xl-3 align-self-center mb-4"
                v-if="popupType == 2"
              >
                <b-form-group>
                  <multiselect
                    :options="Ratings"
                    :disabled="$route.query.mpm_id ? true : false"
                    :multiple="false"
                    track-by="rat_id"
                    label="rat_name"
                    placeholder="Select Rating Type"
                    v-model="pagesList.ratingType"
                  ></multiselect>
                  <label
                    style="color:red !important;"
                    v-if="error.ratingType_error_msg"
                    >please select rating</label
                  >
                </b-form-group>
              </div>

              <div
                class="col-lg-4 col-xl-3 align-self-center mb-4"
                v-if="popupType == 2 || popupType == 1 || popupType == 0"
              >
                <b-form-group>
                  <label for="logo">
                    Banners
                    <br />Size: {{ imageSize.width }}*{{ imageSize.height }}
                  </label>
                  <input
                    name="image_arr"
                    ref="fileinput"
                    v-on:change="uploadBanner($event.target)"
                    accept="image/jpeg, image/png, image/gif"
                    type="file"
                    multiple
                    :disabled="popupType == 0"
                  />
                  <input type="hidden" v-model="pagesList.banner" />
                </b-form-group>
                <div
                  style="cursor: pointer"
                  @click="seeImagesFill('banner', -1)"
                  v-if="pagesList.banner"
                >
                  <u>See {{ pagesList.banner.split(",").length }} images</u>
                </div>
                <label
                  style="color:red !important;"
                  v-if="error.banner_error_msg"
                  >please select image</label
                >
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-form-input
                      type="text"
                      v-model="pagesList.popup_rating_title"
                      id="poptitle"
                      placeholder="pop title"
                    ></b-form-input>
                    <label>Pop up title</label>
                  </div>
                </b-form-group>
                <label
                  style="color:red !important;"
                  v-if="error.popup_rating_title_error_msg"
                  >title is required</label
                >
              </div>

              <div
                v-if="popupType == 3"
                class="col-lg-4 col-xl-3 align-self-center mb-4"
              >
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-form-input
                      type="text"
                      v-model="pagesList.welcome_url"
                      id="welcome_url"
                      placeholder="welcome url"
                    ></b-form-input>
                    <label>Welcome URL</label>
                  </div>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="pagesList.country_id"
                    :disabled="$route.query.mpm_id ? true : false"
                    :options="countryOptions"
                    track-by="country_id"
                    label="country_name"
                    :multiple="true"
                    placeholder="Select Country"
                  ></multiselect>
                  <!-- @select="popupSelect" -->
                </b-form-group>
                <label
                  style="color:red !important;"
                  v-if="error.country_id_error_msg"
                  >country is required</label
                >
              </div>
              <div
                class="col-lg-4 col-xl-3 align-self-center mb-4"
                v-if="popupType == 1"
              >
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-form-input
                      type="text"
                      v-model="pagesList.popup_rating_url"
                      id="poptitle"
                      placeholder="pop url"
                    ></b-form-input>
                    <label>Popup Banner Image Url</label>
                  </div>
                </b-form-group>
                <label
                  style="color:red !important;"
                  v-if="error.popup_rating_url_error_msg"
                  >redirect url is required</label
                >
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-checkbox
                  v-model="pagesList.isActive"
                  unchecked-value="N"
                  value="Y"
                  class="j-checkbox ml-3 mb-3"
                >
                  Is Active
                </b-form-checkbox>
                <!-- <label style="color:red !important;" v-if="error.isActive_error_msg">isActive is required</label> -->
              </div>
              <div class="input-material-textarea">
                <div
                  class="col-lg-12 align-self-center mb-4"
                  v-if="popupType != 1"
                >
                  <div class="descriptionSection font-weight-bold fs-14 mb-3">
                    Description
                  </div>
                  <div class="" v-if="isEdit">
                    <vue-editor
                      v-model="pagesList.description"
                      name="page"
                      id="page"
                    ></vue-editor>
                  </div>
                </div>
              </div>
              <label
                class="col-lg-12 align-self-center"
                style="color:red !important;"
                v-if="error.description_error_msg"
                >Description is required</label
              >
            </b-row>

            <b-row class="m-2">
              <b-col sm="4">
                <b-button
                  type="submit"
                  size="sm"
                  variant="primary"
                  :disabled="popupType == 0"
                >
                  <i class="fa fa-dot-circle-o"></i>
                  Add
                </b-button>
              </b-col>
              <b-col sm="4">
                <b-button
                  @click="resetStaticBanner"
                  size="sm"
                  variant="success"
                >
                  <i class="fa fa-dot-circle-o"></i> Reset
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-modal
        id="modalPopover"
        title="See Images"
        ref="showImages"
        @ok="onOkay"
      >
        <div>
          <draggable
            v-model="bannerImg"
            ref="bannerImg"
            class="d-flex justify-content-center flex-wrap"
            group="image"
            @start="drag = true"
            @end="drag = false"
          >
            <div
              sm="4"
              v-for="(item, index) in bannerImg"
              :key="index"
              class="m-2"
            >
              <img
                :src="
                  item.startsWith('http')
                    ? item.replace(/([^:]\/)\/+/g, '$1')
                    : IMGBASEURL + item
                "
                style="width:100px;height:100px"
              />
              <div class="m-2">
                <button class="btn-blue" @click="removeImagesFill(index)">
                  Remove
                </button>
              </div>
            </div>
          </draggable>
        </div>
      </b-modal>
    </div>
    <b-modal
      id="ModalConfirmationOnSubmit"
      ref="ModalConfirmationOnSubmit"
      @ok="handleModalOkay"
      :title="modalObject.title"
      class="center-footer"
      footer-class="justify-content-center border-0"
      cancel-variant="outline-danger"
      ok-variant="outline-success"
      centered
      hide-header
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="d-block text-center">
        <div>{{ modalObject.message }}</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import { VueEditor } from "vue2-editor";
import { BASEURL, IMGBASEURL } from "@/config/index";

export default {
  name: "AddPopupPages",
  data() {
    return {
      IMGBASEURL: IMGBASEURL,
      editMode: false,
      bannerType: "",
      bannerIndex: "",
      BaseURL: "",
      Ratings: [],
      isEdit: true,
      staticNames: {
        name: "Add"
      },
      modalObject: {
        title: "fdsfds"
      },
      cinemaListArray: [],
      popupType: 0,
      countryOptions: [],
      LanguageArray: [],
      pageList: [
        { pop_id: 3, pop_name: "Welcome" },
        { pop_id: 1, pop_name: "Popup" },
        { pop_id: 2, pop_name: "Rating" }
      ],
      pagesList: {
        pp_id: "",
        mpm_id: "",
        main_name: "",
        country_id: "",
        description: "",
        language: "",
        popup_rating_url: "",
        isActive: false,
        popup_rating_title: "",
        banner: "",
        status: "Y",
        ratingType: "",
        welcome_url: ""
      },
      error: {
        mpm_id_error_msg: false,
        main_name_error_msg: false,
        country_id_error_msg: false,
        description_error_msg: false,
        language_error_msg: false,
        popup_rating_url_error_msg: false,
        isActive_error_msg: false,
        popup_rating_title_error_msg: false,
        banner_error_msg: false,
        status_error_msg: false,
        ratingType_error_msg: false
      },
      imageSize: {
        width: 125,
        height: 125
      },

      imagesVmodel: "",
      imagesIndex: "",
      bannerImg: []
    };
  },
  components: {
    VueEditor,
    draggable
  },
  computed: {},
  watch: {
    "pagesList.main_name"(newValue) {
      console.log("watcher:", newValue);
      if (newValue == null) {
        this.popupType = 0;
      } else {
        this.popupType = newValue ? newValue.pop_id : "";
      }
    }
  },
  async beforeMount() {
    const { movieId, mpm_id } = this.$route.query;
    if (this.$route.query.pp_id) {
      this.editMode = true;
    }
    await this.getRatingList();
    await this.getLanguagesList();
    await this.getActiveCountries();
  },
  mounted: function() {},
  methods: {
    getPopupData(id) {
      const payload = id;
      ExhibitorService.getSinglePopup(payload)
        .then(response => {
          const { data } = response;

          if (data.status && data.Records.length > 0) {
            let popupData = data.Records[0];
            let countryArr =
              popupData.pp_country_id != ""
                ? popupData.pp_country_id.split(",")
                : "";

            let main_name = this.pageList.filter(
              objVal => objVal.pop_id == popupData.pp_type_id
            );
            let country_id = this.countryOptions.filter(objVal =>
              countryArr.includes(`${objVal.country_id}`)
            );
            let description = popupData.pp_description;
            let language = this.LanguageArray.filter(
              objVal => objVal.lang_id == popupData.pp_lang_id
            );
            let popupUrl = popupData.pp_image_url;
            let isActive = popupData.is_active;
            let pp_rating_type = this.Ratings.filter(
              objVal => objVal.rat_id == popupData.pp_rating_type
            )[0];
            let pp_banner = popupData.pp_banner;
            let pp_title = popupData.pp_title;
            let pp_id = popupData.pp_id;

            this.pagesList = {
              mpm_id: "",
              pp_id: pp_id,
              main_name: main_name[0],
              country_id: country_id,
              description: description,
              language: language[0],
              popup_rating_url: popupUrl,
              isActive: isActive,
              popup_rating_title: pp_title,
              banner: pp_banner,
              ratingType: pp_rating_type
            };

            if (main_name[0].pop_id == 1) {
              this.imageSize.width = 466;
              this.imageSize.height = 583;
            } else if (main_name[0].pop_id == 2) {
              this.imageSize.width = 125;
              this.imageSize.height = 125;
            } else if (main_name[0].pop_id == 3) {
              this.imageSize.width = 466;
              this.imageSize.height = 583;
              this.pagesList.welcome_url = popupUrl;
            }
          } else {
            // Show Errors
            //console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          //console.log("show error :", error);
        });
    },
    onOkay() {
      if (this.imagesIndex < 0) {
        this.pagesList[this.bannerType] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.bannerIndex][
          this.bannerType
        ] = this.bannerImg.join(",");
      }
    },
    seeImagesFill(model_name, index) {
      this.imagesIndex = index;
      this.imagesVmodel = model_name;
      this.bannerType = model_name;
      this.bannerIndex = index;
      if (this.imagesIndex < 0) {
        this.bannerImg = this.pagesList[this.imagesVmodel].split(",");
      } else {
        this.bannerImg = this.pagesList.otherData[this.imagesIndex][
          this.imagesVmodel
        ].split(",");
      }
      this.$refs.showImages.show();
    },
    removeImagesFill(index) {
      this.imagesIndex = -1;
      this.imagesVmodel = "banner";

      this.bannerImg.splice(index, 1);

      if (this.imagesIndex < 0) {
        this.pagesList[this.imagesVmodel] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.imagesIndex][
          this.imagesVmodel
        ] = this.bannerImg.join(",");
      }

      this.$refs.showImages.hide();
    },
    addBannerFormat() {
      let obj = {
        main_name: "",
        header_name: "",
        description: "",
        images: "",
        cover_image: "",
        o_status: "Y"
      };
      this.pagesList.otherData.push(obj);
    },
    removeBannerImage(index) {
      this.pagesList.otherData[index]["o_status"] = "N";
    },
    getRatingList: function() {
      let payload = {
        tableName: "ms_ratings",
        rating_is_active: "Y"
      };
      if (this.Ratings.length === 0) {
        MasterService.GetActiveList(payload)
          .then(response => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Ratings = data.Records.map((value, index) => ({
                rat_id: value.rating_id,
                rat_name: value.rating
              }));

              //console.log(this.Ratings,data.Records);
            } else {
              // Show Errors
              //console.log("show error :", data.message);
            }
          })
          .catch(error => {
            // Show Catch Error
            //console.log("show error :", error);
          });
      }
    },
    popupSelect: function(popupList) {
      //get Rating Types..
      if (popupList.pop_id == 1) {
        this.popupType = popupList.pop_id;
        this.imageSize.width = 466;
        this.imageSize.height = 583;
        this.removeImagesFill(0);
      } else if (popupList.pop_id == 2) {
        this.popupType = popupList.pop_id;
        this.imageSize.width = 125;
        this.imageSize.height = 125;
        this.removeImagesFill(0);
        console.log(this.popupType);
      }
      //console.log(this.pagesList);
    },
    getLanguagesList: function() {
      // getCountriesList

      let payload = {
        tableName: "ms_language",
        lang_is_active: "Y"
      };
      return MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            //console.log("langres", data.Records);
            this.LanguageArray = data.Records;
          } else {
            //console.log("Error from language", data.message);
          }
        })
        .catch(error => {
          //console.log(error, "from language catch");
        });
    },

    selectAllCinema: function(cinemaList) {
      if (cinemaList.CinemaName == "All") {
        setTimeout(x => {
          this.staticBanner.CinemaIDArray = this.cinemaListArray.filter(x => {
            return parseInt(x.CinemaID) > 0;
          });
        }, 100);
      }
    },
    getBannersDetails: function(pageid) {
      let payload = {
        pageid
      };

      return false;
    },
    submitStaticBanner: function() {
      if (!this.staticBanner.pagename) {
        this.showMessageSnackbar("Please Select Any Movie");
      } else if (!this.staticBanner.LanguageID) {
        this.showMessageSnackbar("Please Select Any Language");
      } else if (!this.staticBanner.banners) {
        this.showMessageSnackbar("Please Select Banner Image");
      } else {
        let payload = {
          title: "Confirmation",
          message: "Please re-check the data before submit"
        };
        this.showSubmitConfirmation(payload);
      }
    },

    uploadAppThumbBanner: function(image) {
      let refs = this.$refs;
      var self = this;
      var _URL = window.URL || window.webkitURL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = async function() {
          // if (img.height != 254 || img.width != 179) {
          //   // if (false) {
          //   self.$refs["fileinput"].reset();
          //   self.showMessageSnackbar("Please upload a 1520x500 image");
          // } else {
          var formdata = new FormData();
          formdata.append("assets/images/movies/banners", image.files[0]);
          UploadService.uploadFiles(formdata)
            .then(response => {
              response.data.Message
                ? self.showMessageSnackbar(response.data.Message)
                : "";

              if (response.data.Status) {
                self.staticBanner.appthumbimage = response.data.Path;
                self.BaseURL = response.data.BaseURL;
              }
            })
            .catch(error => {
              //console.log("Catch on AddStaticImages-onUpload Error: ", error);
              self.showMessageSnackbar(
                "Oops! Something went wrong. kindly contact your administrator"
              );
            });
          // }
        };
      }
    },

    uploadMobileBanner: function(image) {
      let refs = this.$refs;
      var self = this;
      var _URL = window.URL || window.webkitURL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = async function() {
          if (
            img.height != this.imageSize.height ||
            img.width != this.imageSize.width
          ) {
            // if (false) {
            // self.$refs["fileinput"].reset();
            self.showMessageSnackbar("Please upload a 400x500 image");
          } else {
            var formdata = new FormData();
            formdata.append("assets/images/movies/banners", image.files[0]);
            UploadService.uploadFiles(formdata)
              .then(response => {
                response.data.Message
                  ? self.showMessageSnackbar(response.data.Message)
                  : "";

                if (response.data.Status) {
                  self.staticBanner.appbanner = response.data.Path;
                  self.BaseURL = response.data.BaseURL;
                }
              })
              .catch(error => {
                //console.log("Catch on AddStaticImages-onUpload Error: ", error);
                self.showMessageSnackbar(
                  "Oops! Something went wrong. kindly contact your administrator"
                );
              });
          }
        };
      }
    },

    resetStaticBanner: function() {
      this.pagesList.country_id = "";
      this.pagesList.language = "";
      this.pagesList.ratingType = "";
      this.pagesList.popup_rating_url = "";
      this.pagesList.popup_rating_title = "";
      this.pagesList.welcome_url = "";
      // this.bannerImg = [];
      this.pagesList.description = "";
      this.removeImagesFill(0);
      this.$refs.popupform.reset();
    },
    // Show Confirmmation Dialog
    handleModalOkay: function(evt) {
      // evt.preventDefault();
      this.modalObject.count = 1;
      this.submitFinalData();
    },
    showSubmitConfirmation: function(payload) {
      this.modalObject.title = payload.title; // "Confirmation";
      this.modalObject.message = payload.message; // "Please re-check the data before submit";
      this.openModal("ModalConfirmationOnSubmit");
    },
    openModal: function(ref) {
      this.$refs[ref].show();
    },
    closeModal: function(ref) {
      this.$refs[ref].hide();
      this.modalObject.title = ""; // "Confirmation";
      this.modalObject.message = ""; // "Please re-check the data before submit";
    },
    // Show Confirmmation Dialog End
    // Show Error Message
    showMessageSnackbar: function(Message) {
      let x = document.getElementById("snackbar");
      x.className = "show";
      x.innerHTML = Message;
      setTimeout(function() {
        x.className = "";
        x.innerHTML = "";
      }, 6000);
    },
    uploadBanner: function(image) {
      //console.log(image.files);
      let refs = this.$refs;
      var self = this;
      var _URL = this.BASE_URL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();

        let img_data = "";
        var files = image.files;
        var file = image.files[0];

        var width, height;
        let reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = evt => {
          let img = new Image();
          img.onload = () => {
            console.log(img.width, img.height, "hdhdh");

            console.log(image, "height:", img.height, "width:", img.width);
            if (
              img.height != this.imageSize.height ||
              img.width != this.imageSize.width
            ) {
              self.showMessageSnackbar(
                `Please upload a ${this.imageSize.width}x${this.imageSize.height} image`
              );
            } else {
              const formData = new FormData();
              for (const i of Object.keys(files)) {
                //console.log("imagesformdata", `${_URL}/uploads/${files[i].name}`);
                formData.append("image_arr", files[i]);
              }
              ExhibitorService.MultipleImages(formData)
                .then(response => {
                  //console.log(response);
                  const { data } = response;
                  this.bannerImg = data.path;

                  this.pagesList.banner = this.bannerImg.toString();

                  //console.log(this.pagesList.banner, "bannerImg");
                })
                .catch(error => {
                  //console.log(error);
                });
            }
          };
          img.src = evt.target.result;
        };
      }
    },
    uploadImageHandler: function(image, name, size, index) {
      //console.log(image.files);
      let refs = this.$refs;
      var self = this;
      var _URL = this.BASE_URL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();

        let img_data = "";
        var files = image.files;

        const formData = new FormData();
        for (const i of Object.keys(files)) {
          formData.append("image_arr", files[i]);
        }
        ExhibitorService.MultipleImages(formData)
          .then(response => {
            //console.log(response);
            const { data } = response;
            this.bannerImg = data.path;
            this.pagesList.otherData[index][name] = this.bannerImg.toString();

            //console.log(this.pagesList.otherData[index][name], "bannerImg");
          })
          .catch(error => {
            //console.log(error);
          });
      }
    },
    getActiveCountries(country_id, flag) {
      let body = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.countryOptions = data.Records;
              //console.log("this.ActiveCountries :>> ", this.countryOptions);
              if (this.editMode) {
                this.getPopupData(this.$route.query.pp_id);
              }
            }
          }
          // else
          // this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    validateData() {
      if (this.pagesList.main_name.pop_id == 1) {
        //Language Validation

        if (!this.pagesList.language) {
          this.error.language_error_msg = true;
          return false;
        } else if (!this.pagesList.language.lang_id) {
          this.error.language_error_msg = true;
          return false;
        } else {
          this.error.language_error_msg = false;
        }

        //Banner Validation

        if (!this.pagesList.banner) {
          console.log("hello");
          this.error.banner_error_msg = true;
          return false;
        } else {
          this.error.banner_error_msg = false;
        }

        //Title Validation

        if (!this.pagesList.popup_rating_title) {
          console.log("hello");
          this.error.popup_rating_title_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_title_error_msg = false;
        }

        //Country Validation

        if (!this.pagesList.country_id.length > 0) {
          this.error.country_id_error_msg = true;
          return false;
        } else {
          this.error.country_id_error_msg = false;
        }

        //Banner URL Validation

        if (!this.pagesList.popup_rating_url.length > 0) {
          this.error.popup_rating_url_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_url_error_msg = false;
        }

        // Verification Done!
        return true;
      } else if (this.pagesList.main_name.pop_id == 2) {
        if (!this.pagesList.language) {
          this.error.language_error_msg = true;
          return false;
        } else if (!this.pagesList.language.lang_id) {
          this.error.language_error_msg = true;
          return false;
        } else {
          this.error.language_error_msg = false;
        }

        //Rating Validation
        console.log(this.pagesList.ratingType);

        if (!this.pagesList.ratingType) {
          this.error.ratingType_error_msg = true;
          return false;
        } else if (!this.pagesList.ratingType.rat_id) {
          this.error.ratingType_error_msg = true;
          return false;
        } else {
          this.error.ratingType_error_msg = false;
        }

        //Banner Validation

        if (!this.pagesList.banner) {
          console.log("hello");
          this.error.banner_error_msg = true;
          return false;
        } else {
          this.error.banner_error_msg = false;
        }

        //Title Validation

        if (!this.pagesList.popup_rating_title) {
          console.log("hello");
          this.error.popup_rating_title_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_title_error_msg = false;
        }

        //Country Validation

        if (!this.pagesList.country_id.length > 0) {
          this.error.country_id_error_msg = true;
          return false;
        } else {
          this.error.country_id_error_msg = false;
        }

        //Description Validation

        if (!this.pagesList.description) {
          console.log("hello");
          this.error.description_error_msg = true;
          return false;
        } else {
          this.error.description_error_msg = false;
        }

        // Verification Done!
        return true;
      } else if (this.pagesList.main_name.pop_id == 3) {
        if (!this.pagesList.language) {
          this.error.language_error_msg = true;
          return false;
        } else if (!this.pagesList.language.lang_id) {
          this.error.language_error_msg = true;
          return false;
        } else {
          this.error.language_error_msg = false;
        }

        //Title Validation
        if (!this.pagesList.popup_rating_title) {
          this.error.popup_rating_title_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_title_error_msg = false;
        }

        //Country Validation
        if (!this.pagesList.country_id.length > 0) {
          this.error.country_id_error_msg = true;
          return false;
        } else {
          this.error.country_id_error_msg = false;
        }

        //Description Validation
        if (!this.pagesList.description) {
          console.log("hello");
          this.error.description_error_msg = true;
          return false;
        } else {
          this.error.description_error_msg = false;
        }

        // Verification Done!
        return true;
      } else {
        if (this.pagesList.main_name.pop_id) {
          return false;
        }
      }
    },
    submitFinalData() {
      if (this.validateData()) {
        let loader = this.$loading.show();
        let testArr = [];
        let all_country_ids = Array.isArray(this.pagesList.country_id)
          ? this.pagesList.country_id.map(v => v.country_id).join(",")
          : "";

        const popupData = {
          pp_id: this.editMode ? this.pagesList.pp_id : undefined,
          pp_type_id:
            this.pagesList.main_name && this.pagesList.main_name.pop_id
              ? this.pagesList.main_name.pop_id
              : "",
          pp_name:
            this.pagesList.main_name && this.pagesList.main_name.pop_name
              ? this.pagesList.main_name.pop_name
              : "",
          pp_lang_id:
            this.pagesList.language && this.pagesList.language.lang_id
              ? this.pagesList.language.lang_id
              : "",
          pp_rating_type:
            this.pagesList.ratingType && this.pagesList.ratingType.rat_id
              ? this.pagesList.ratingType.rat_id
              : "",
          pp_banner: this.pagesList.banner.startsWith("http")
            ? new URL(this.pagesList.banner).pathname
            : this.pagesList.banner,
          pp_title: this.pagesList.popup_rating_title,
          pp_country_id: all_country_ids,
          pp_image_url: this.pagesList.popup_rating_url,
          pp_description: this.pagesList.description,
          is_active: this.pagesList.isActive
        };

        if (this.pagesList.main_name.pop_id == 3) {
          popupData.pp_image_url = this.pagesList.welcome_url || "";
        }

        testArr.push(popupData);
        let payload = {
          popupPages: testArr
        };
        //console.log(payload);
        ExhibitorService.AddPopup(payload)
          .then(response => {
            const { data } = response;
            if (!this.editMode) {
              this.resetStaticBanner();
            }
            this.$toasted.show(data.message);
            this.$router.go(-1);
          })
          .catch(err => {
            //console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      } else {
        console.error("Validation Error");
      }
    }
  },
  updated() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/add-popup-pages.vue